/**
 * Shared "is this a paid coach" predicate (Product Decision §1 — coach
 * instruction extraction / teaching-video upload is a paid-coach-only
 * feature).
 *
 * Extracted so `TeachingVideoUploader.tsx` (which gates the whole upload
 * panel behind this) and `CreateTemplate.tsx` (which branches the YouTube-
 * transcript copy on the same condition — FE-10) cannot drift onto two
 * different definitions of "paid coach". An admin always counts as a paid
 * coach (admins can exercise every paid feature without a `tier` flip).
 */
import type { User } from '@/types/auth';

export function isPaidCoach(user: User | null): boolean {
  return (
    user !== null &&
    (user.role === 'coach' || user.role === 'admin') &&
    (user.tier === 'paid' || user.role === 'admin')
  );
}
